var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1395 10.2626L16.3753 10.9292H17.0823H17.3453C19.346 10.9292 21 12.5608 21 14.5327C21 16.5047 19.346 18.1363 17.3453 18.1363H5.06905C3.9287 18.1363 3 17.2076 3 16.0673C3 14.9269 3.9287 13.9982 5.06905 13.9982H5.14624H5.96287L6.12607 13.1981C6.36462 12.0284 7.32931 11.116 8.52306 10.9546L9.13356 10.8721L9.33444 10.2897C9.82807 8.85867 11.1966 7.86011 12.7417 7.86011C14.2769 7.86011 15.6383 8.84579 16.1395 10.2626Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.333d0e55.svg";
export { ForwardRef as ReactComponent };